export enum EGoogleTagEvents {
  BeginCheckout = 'begin_checkout',
  Purchase = 'purchase',
  SignUp = 'sign_up',
  Conversion = 'conversion',
}
